/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'string',
      maxLength: 255,
    },
  },
  required: ['value'],
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    contact_person_email: valueSchema,
  },
}
